export default __webpack_public_path__ + "static/media/icon-psy.687b6d26.svg";